<template>
    <div class="collage-image flex relative">
        <div class="absolute inset-0 grid place-content-center black-transparent group">
            <div class="w-8 h-8 rounded-full text-white font-bold bg-gold-500 grid place-content-center transform transition-all group-hover:scale-150">
                &lt;&gt;
            </div>
        </div>
        <img
            class="w-1/2 object-cover object-left border-r-2 border-gold-500"
            :src="image.before.thumb"
            :alt="image.title">
        <img
            class="w-1/2 object-cover object-right"
            :src="image.after.thumb"
            :alt="image.title">
    </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
    .collage-image {
        aspect-ratio: 1;
    }
    .black-transparent:hover {
        background-color: rgba(3, 3, 4, 0.2);
    }
</style>
